/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
// import importBaseUrl from "../ImportBaseUrl";
import Loader from "../../Loader";
// import Pagination from "react-js-pagination";
import { useNavigate, Link } from 'react-router-dom';

 
const Step1 = ({ onNext, cid, role,token,formData, setFormData })  => {
   
    // const [formData, setFormData] = useState([]);
    const [companyList, setcompanyList] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    
    const [validationErrors, setValidationErrors] = useState({
        file: false,
        cname: false,
      });
    const [file, setFile] = useState('');
    


    useEffect(() => {
       if(token){
        getCustomerNameList();
       } 
    }, [token]);    
    
   
 
   
    

    const handleCompanyChange = (e) => {
        setSelectedValue(e.target.value);
        setFormData({ ...formData,  company_id: e.target.value });
    }; 
 
   
    const getCustomerNameList = async () => {
        try {
          
            const response = await axios.get(`${baseUrl}/active-user-company`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            const allArray = response.data.filter(item => item.id !== 1);
            setcompanyList(allArray);
            
        } catch (error) {
           console.log(error);
            
        }
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
      };

    const handleNextClick = async(e) => {
        e.preventDefault();
        const newValidationErrors = {
            file:file == '',
            cname : selectedValue == ''
          };
         
          setValidationErrors(newValidationErrors);
          const hasErrors = Object.values(newValidationErrors).some((error) => error);
     
        if(!hasErrors){
            console.log("okay");
            console.log(selectedValue, "select");
            console.log(file, "file");
            setFormData({ ...formData, file: file });
            onNext();
        
        }
       
    };

   
    return (
        <>
            
              
                    {/* {renderStep()} */}
                    
            <div className="row">
                <div className="col-8">
                    <div className="left-title">
                        <h1>DMT Sync</h1>
                    </div>
                </div>


                <div className="col-4 top-right-buttons">   
                    <div className="export-btn addnew-button"><Link to="/import-dmt-sync-history">History</Link></div>
                    <div className="export-btn addnew-button"><Link to="/imports-list"><span>&larr;</span> Back</Link></div>
                    </div>  
                
            </div>
            <div className="common-white-shadow-background setting-section">
            <div className="row">
                <h3 className='comapny-label'>Select Company</h3>
                <div className="inputbox">
                    <select name="" id=""  value={selectedValue} onChange={(e) => handleCompanyChange(e)}>
                        <option value="">Select Company</option>
                        {companyList.map((comp) => (                                                                    
                                <option key={comp.id} value={comp.id}>
                                    {comp.cname}
                                </option>  
                            ))}
                    </select>
                </div>
            </div>
            {validationErrors.cname && <p className="error">Please select a value from the dropdown.</p>}
        </div>
            <div className="common-white-shadow-background setting-section">
                <div className="row">
                    
                    <h3>Upload File (Using Template)</h3>
                    <div className="download-templte">
                    <a  className="newrow" target="_blank" href={`${process.env.PUBLIC_URL}/template/Import_Template.xlsx`} download="Import_DMT_Sync.xlsx">Download Template</a><p>Submissions must be in the format of this template</p>
                    </div>
                    <div className="file-upload-field">
                        <div className="upload-btn-wrapper">
                              <input type="file" name="myfile" onChange={handleFileChange} placeholder="Select your local file based on our template" />
                            </div>
                    </div>
                    {validationErrors.file && (
        <p className="error">Please choose a file.</p>
      )}
                </div>
            </div>            

            <div className="row footer-row">
                {/* <a href="#" className="Cancel">Cancel</a> */}
                <a href="#" className='next' onClick={handleNextClick}>Next</a>
            </div>
        </>
                
    )
}

const Step2 = ({ onBack, onNext, role,token, formData, setFormData }) => {

    const [popupOpen, setPopupOpen] = useState(false);
    const [sansayList, setSansayList] = useState([]);
    const [selectedSansay, setSelectedSansay] = useState("");
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const navigate = useNavigate();
    
    useEffect(() => {
        // Make the API call when the component mounts
        getPrimaryTrunk();
    }, [formData.company_id]);
    
    const getPrimaryTrunk = async () => {
        try {
            
        
           
            setPopupOpen(true);
            const response = await axios.get(`${baseUrl}/user-company-priority-sansay/${formData.company_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            const allArray = response.data;
            console.log(allArray);
            setSansayList(allArray.sansayList);
            if(allArray.sansayList.length == 1){
                setSelectedSansay(allArray.sansayList[0].name);
                setFormData({ ...formData, selectedSansay: allArray.sansayList[0].name });
            }
        
        setPopupOpen(false);
          
        } catch (error) {
            setPopupOpen(false);
           console.log(error);
            
        }
    };

    const handleCheckboxChange = (item) => {
     
        setSelectedSansay(item.name);
        setFormData({ ...formData, selectedSansay: item.name });
    };

    const handleNextClick = async(e) => {
        e.preventDefault();
      
        if(window.confirm(`This process will not update the Sansay, it will only update the portal DMT information.  Please confirm that for the imported phone numbers you would like to remove all DMTs from the portal and use the ${formData.selectedSansay} Sansay to insert DMT information for Standard and Offnet DMTs into the portal.`)){
            console.log(formData);
            setButtonDisabled(true);
            setPopupOpen(true);
            const newData = new FormData();
            newData.append("file", formData.file);
            newData.append('company_id', formData.company_id);       
            newData.append('selected_sansay', formData.selectedSansay);               
                
            axios.post(`${baseUrl}/import-dmt-sync`, newData,{
                headers: {
                     Authorization: `Bearer ${token}`,
                     "Content-Type": "multipart/form-data",
                }
            });   
                    
            navigate("/order-new-number-success", { state: {
                importDMTSync : true
            } }); 
        }
 
            
        
       
    };


    return(
   
        <>
        {popupOpen && (
                     <Loader /> 
                ) }
            <div className="row">
                <div className="col-6">
                    <div className="left-title">
                        <h1>Select Primary Sansay</h1>
                        {/* <small>(Order Summary Step 3)</small> */}
                    </div>
                </div>
                <div className="col-6">
                </div>
            </div>
            <div className="common-white-shadow-background setting-section tableinput-section">
                <div className="row footer-row">
                    <div className="footer-row-left">
                        <a href="#" onClick={onBack} className="Back"> <img src="images/back-arrow.png" />Back</a>
                    </div>
                    <div className="footer-row-right">
                    <Link className="Cancel" to={"/number-management"}>Cancel</Link>
                        <a href="#" onClick={handleNextClick} className={buttonDisabled ? "next disable-link" : "next"}>Import</a>
                    </div>
                </div>
            </div>
            <div className="common-white-shadow-background setting-section">
                <div className="row">
                    <div className=" setting-section haft-whitebox">
                    <table className="tablebox search-result-table inventory-table">
                                    <thead>
                                        <tr>
                                        <th>Sansay Name</th>
                                        <th>Action</th>
                                        </tr>
                                        </thead>
                                    <tbody>
                                    {sansayList.map((item, index) => (
                                        <tr key={index}>                                            
                                            <td>{item.name}</td>
                                            <td><input type="checkbox" onChange={() => handleCheckboxChange(item)} checked={selectedSansay  && selectedSansay == item.name}  /></td>
                                        </tr>))}
                                    </tbody>
                                </table>
                    </div>
                </div>
            </div>
            
    
        </>)    
}
 
// export default Step1;

const ImportDMTSync = () => {

    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [cid, setCid] = useState('');
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState([]);

    const navigate = useNavigate();

    const handleNext = () => setStep(step + 1);
    const handleBack = () => setStep(step - 1);


    useEffect(() => {
        refreshToken();
        getUserAccess();
    }, []);

    useEffect(() => {
        if(access.length > 0 && token){
            checkAccess(access, token);
        }
    }, [access, token]);

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded.exp);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            console.log(response.data.results);
            setAccess(response.data.results);
            // setIsLoading(false);
            
        } catch (error) {
           console.log(error);
        
        }
    }

    const checkAccess = async (access) => {
        if(role > 2){
            navigate('/dashboard');
        }
    }

    
 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
 
    const renderStep = () => {
        switch (step) {
          case 1:
            return <Step1 onNext={handleNext} cid={cid} role={role} token={token} formData={formData} setFormData={setFormData} />;       
          case 2:
            return <Step2 onBack={handleBack} onNext={handleNext} cid={cid} role={role} token={token} formData={formData} setFormData={setFormData} />;        
           
          default:
            return null;
        }
      };

return (
    <div className="panelbox">
       <Navbar  token={token} access = {access}/>
        <div className="right-panel">
        <Header name={name} />
            <div className="content-page">
           
            {renderStep()}                   
            </div>
        </div>
    </div>
)
}

export default ImportDMTSync